import MUICircularProgress from '@mui/material/CircularProgress'

export const CircularProgress = MUICircularProgress
